import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card splash-screen" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-md-9 mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "splash-screen--title"
}
const _hoisted_5 = { class: "splash-screen--linkitems" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "splash-screen--byline" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RundeckVersion = _resolveComponent("RundeckVersion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.system.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_RundeckVersion, {
                    title: _ctx.system.appInfo.title,
                    number: _ctx.system.versionInfo.number,
                    tag: _ctx.system.versionInfo.tag,
                    logocss: _ctx.system.appInfo.logocss
                  }, null, 8, ["title", "number", "tag", "logocss"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.system.appInfo.title !== 'Rundeck')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("a", {
                      href: "https://support.rundeck.com/",
                      target: "_blank",
                      class: "item"
                    }, [
                      _createElementVNode("i", { class: "fas fa-first-aid" }),
                      _createTextVNode(" Support")
                    ], -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("a", {
                      href: "https://github.com/rundeck/rundeck/issues",
                      target: "_blank",
                      class: "item"
                    }, [
                      _createElementVNode("i", { class: "fab fa-github" }),
                      _createTextVNode(" Issues ")
                    ], -1)
                  ]))])),
              _createElementVNode("a", {
                href: _ctx.links.help,
                target: "_blank",
                class: "item"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-book" }, null, -1),
                _createTextVNode(" Docs", -1)
              ]))], 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "To get started, create a new project.", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: _ctx.links.frameworkCreateProject,
                  class: "btn btn-primary btn-lg"
                }, [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Create New Project ", -1),
                  _createElementVNode("b", { class: "glyphicon glyphicon-plus" }, null, -1)
                ]))], 8, _hoisted_10)
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-md-3 bg-white rounded p-6 shadow\" data-v-50d59958><div class=\"welcome-section\" data-v-50d59958><div class=\"l1\" data-v-50d59958>First Steps</div><div class=\"l2\" data-v-50d59958>to Learn</div><div class=\"l3\" data-v-50d59958>Automation</div></div><div style=\"margin-top:12px;text-align:center;\" data-v-50d59958><a href=\"https://docs.rundeck.com/docs/learning/\" target=\"_blank\" class=\"btn btn-default btn-lg\" data-v-50d59958>Learn Here</a></div></div>", 1))
        ]))
      : _createCommentVNode("", true)
  ]))
}